import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { HeaderComponent } from './header.component';
import { NavComponent } from './navigation.component';
import { LeftbarComponent } from './left_sidebar.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })  
  ],
  declarations: [
    NavComponent,   
    HeaderComponent,
    FooterComponent,
    LeftbarComponent 
  ],
  exports: [
    NavComponent,
    HeaderComponent,
    FooterComponent,
    LeftbarComponent
  ]
})
export class GlobalModule { }



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/global/global.module.ts